import type { FrontChat, FrontChatOptions } from './types';

const scriptSrc = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';

// Every support entry point (header, support buttons, modals) boots the chat; share one script load.
let bootPromise: Promise<FrontChat> | undefined;

export const boot = async (element?: HTMLElement, options?: FrontChatOptions): Promise<FrontChat> => {
  if (bootPromise) return bootPromise;

  const scriptTag = document.createElement('script');
  scriptTag.setAttribute('type', 'text/javascript');
  scriptTag.setAttribute('src', scriptSrc);

  if (options?.nonce) {
    scriptTag.setAttribute('nonce', options.nonce);
  }

  const scriptContainer = element ?? document.body;

  bootPromise = new Promise<FrontChat>((resolve, reject) => {
    scriptTag.onload = () => {
      if (!window.FrontChat) {
        throw new Error('[front-chat-sdk] Could not set up window.FrontChat');
      }

      resolve(window.FrontChat);
    };
    scriptTag.onerror = () => {
      // Let the next boot retry instead of every caller waiting on a script that never loads.
      bootPromise = undefined;
      scriptTag.remove();
      reject(new Error('[front-chat-sdk] Could not load the Front chat script'));
    };
  });

  scriptContainer.appendChild(scriptTag);

  return bootPromise;
};

export const initialize = async (chatId: string, element?: HTMLElement) => {
  const frontChat = await boot(element);

  frontChat('init', { chatId });
};
